import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ScCopyCode } from './styled';

interface CopyCodeProps {
  translation: string;
  code: string;
}

export const CopyCode = ({ translation, code }: CopyCodeProps) => {
  const { t } = useTranslation(translation);
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const timeout = timeoutRef.current;

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  const handleCopyCode = () => {
    setIsCopied(true);
    window.navigator.clipboard.writeText(code);
    timeoutRef.current = setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <ScCopyCode>
      <span className="code__title">{t('copyCode')}</span>
      <div
        className="code__btn notranslate"
        onClick={handleCopyCode}
        translate="no"
      >
        {isCopied ? t('copied') : code}
      </div>
    </ScCopyCode>
  );
};
